if ($('.floorplan-elevation').length) {
  $('body').on('click vclick keyup', '.show-all-elevations', function () {
    var button = $(this);
    button.closest('.floorplan-elevation').find('.elevation:nth-child(1n+6)').slideDown();
    button.hide();
    button.closest('.floorplan-elevation').find('.hide-all-elevations').show();
  });
  $('body').on('click vclick keyup', '.hide-all-elevations', function () {
    var button = $(this);
    button.closest('.floorplan-elevation').find('.elevation:nth-child(1n+6)').slideUp();
    button.hide();
    button.closest('.floorplan-elevation').find('.show-all-elevations').show();
  });
}